import { Box, Button, Container, Text, VStack } from '@chakra-ui/react';
import { motion } from 'framer-motion';

const MotionBox = motion(Box);

const GetHiredCTABand = ({ text, buttonText, onButtonClick }) => {
  const scrollToWebinar = () => {
    const element = document.getElementById('webinar-register');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    if (onButtonClick) {
      onButtonClick();
    }
  };

  return (
    <MotionBox
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      viewport={{ once: true, amount: 0.5 }}
      bg="linear-gradient(135deg, #10B981 0%, #059669 100%)"
      py={{ base: 8, md: 10 }}
    >
      <Container maxW="6xl">
        <VStack spacing={4} align="center" textAlign="center">
          <Text
            fontSize={{ base: 'md', md: 'lg' }}
            color="white"
            fontWeight="500"
            maxW="2xl"
            lineHeight="1.6"
          >
            {text}
          </Text>

          <Button
            onClick={scrollToWebinar}
            bg="white"
            color="accent.green"
            fontWeight="700"
            size="lg"
            fontSize="md"
            px={8}
            _hover={{
              bg: 'gray.100',
              transform: 'translateY(-2px)',
            }}
            transition="all 0.3s ease"
          >
            {buttonText} →
          </Button>
        </VStack>
      </Container>
    </MotionBox>
  );
};

export default GetHiredCTABand;
